import i18next from 'i18next';

export const getCsvImporterTranslations = () => ({
    back: i18next.t('Back'),
    cancel: i18next.t('Cancel'),
    change_file: i18next.t('Change file'),
    column: i18next.t('Column'),
    continue: i18next.t('Continue'),
    decimal_separator: i18next.t('Decimal separator'),
    download_example_file: i18next.t('Download the sample CSV'),
    dropzone_text: i18next.t(
        'Drag & drop some file here, or click to select file',
    ),
    field_required: i18next.t('Field required'),
    format: i18next.t('Format'),
    format_error: i18next.t(
        'There appears to be an issue with the data or its format. If you continue, the rows with errors will be ignored. Do you want to continue?',
    ),
    format_match_error: i18next.t(
        'The selected format does not match the value',
    ),
    next: i18next.t('Next'),
    no_file_error: i18next.t('No file provided'),
    row: i18next.t('Row'),
    rows_error: i18next.t('Rows with errors'),
    rows_per_page: i18next.t('Rows per page'),
    save: i18next.t('Save'),
    step_match_label: i18next.t('Match column', { count: 2 }),
    step_review_label: i18next.t('Review'),
    step_upload_label: i18next.t('Upload'),
    total_rows: i18next.t('Total rows'),
    unique_error: i18next.t('Must be unique'),
});
